import React from "react";
import config from "../../config";
import { authFetch } from "../../utils/Security/authFetch";

interface FavoriteCheckboxProps {
  value: boolean;
  data: any;
  node: any;
}

const FavoriteCheckbox: React.FC<FavoriteCheckboxProps> = ({
  value,
  data,
  node,
}) => {
  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedValue = e.target.checked;

    // Optimistically update the UI
    node.setDataValue("isFavorite", updatedValue);

    try {
      const response = await authFetch(
        `${config.apiBaseUrl}/api/incidents/${data.ticketId}/favorite`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ isFavorite: updatedValue }),
        }
      );

      if (!response.ok) {
        throw new Error("Server responded with error");
      }
    } catch (error) {
      console.error("Failed to update favorite:", error);
      // Rollback UI change
      node.setDataValue("isFavorite", !updatedValue);
    }
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()} // Prevent ag-Grid row click on mouse down
    >
      <input type="checkbox" checked={!!value} onChange={handleChange} />
    </div>
  );
};

export default FavoriteCheckbox;
